import React from "react"

const Footer = () => (
  <footer className="container-fluid footer">
    <div className="container footer-nav">                                    
      <div className="footer_row">
        <span style={{ align: 'center' }}>
          <span style={{ paddingRight: '20px' }}>United States Bowling Congress</span>
          <span style={{ paddingRight: '20px' }}>621 Six Flags Drive, Arlington, Texas 76011</span>
          <span style={{ paddingRight: '20px' }}>800-514-BOWL</span>
          <span>USBCCOLLEGIATE@IBCYOUTH.COM</span>
        </span>
          <span style={{ marginLeft: '12%', fontSize: '12px' }}>Build v1.25301.3 </span>
        </div>                                                    
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js